var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile2 = function SvgFile2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M19.167 3.026v5.507c0 .747 0 1.12.145 1.405.128.251.332.455.583.583.285.145.658.145 1.405.145h5.507m.36 2.652v9.615c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-8.534c-2.24 0-3.36 0-4.216-.436A4 4 0 0 1 6.27 27.15c-.436-.855-.436-1.976-.436-4.216V9.067c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.749c.856-.435 1.976-.435 4.216-.435h4.283c.978 0 1.467 0 1.928.11a4 4 0 0 1 1.156.479c.403.247.75.593 1.441 1.285l4.251 4.251c.692.692 1.038 1.038 1.285 1.441.22.358.381.748.48 1.157.11.46.11.95.11 1.928"
  })));
};
export default SvgFile2;